export default function settings_reducer(state = {searchValue:"", lang_version:"en"},action) {
    switch (action.type) {
      case 'SET_SEARCH':
        //console.log(action.activeSideBar+" is reducer");
        return {...state, searchValue:action.searchValue};
  
      case 'SET_LANG':
        return {...state, lang_version:action.lang_version};
  
      default:
        break;
    }
    return state;
  }